var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleAuth = function SvgGoogleAuth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#googleAuth_svg__a)",
    d: "M12 24.001c6.628 0 12.001-5.373 12.001-12 0-6.628-5.373-12.001-12-12.001C5.373 0 0 5.373 0 12c0 6.628 5.373 12.001 12 12.001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#427CFF",
    d: "M12 19.637A7.636 7.636 0 0 1 4.365 12 7.636 7.636 0 0 1 17.4 6.6l3.086-3.086A11.96 11.96 0 0 0 12 0C5.374 0 0 5.373 0 12c0 6.628 5.373 12.001 12 12.001a11.97 11.97 0 0 0 8.487-3.514L17.4 17.4a7.62 7.62 0 0 1-5.4 2.236Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B56FF",
    d: "M19.637 12h-3.819a3.82 3.82 0 0 0-7.636 0c0 1.027.406 1.959 1.066 2.646l-.003.003 4.728 4.728h.001A7.64 7.64 0 0 0 19.637 12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#154ECD",
    d: "M24 12h-4.364a7.64 7.64 0 0 1-5.662 7.378l3.37 3.37A12 12 0 0 0 24 12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillOpacity: 0.1,
    d: "M12 23.863C5.397 23.863.04 18.528.002 11.932L0 12c0 6.628 5.373 12 12 12 6.628 0 12.001-5.372 12.001-12L24 11.932c-.038 6.596-5.396 11.931-12 11.931"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.05,
    d: "m13.975 19.378.107.106a7.64 7.64 0 0 0 5.555-7.347V12a7.64 7.64 0 0 1-5.662 7.377Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B56FF",
    d: "M21.819 10.91H12a1.09 1.09 0 1 0 0 2.18h9.818a1.09 1.09 0 0 0 .001-2.18"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0BEFF",
    d: "M21.819 10.91H12a1.09 1.09 0 1 0 0 2.18h9.818a1.09 1.09 0 0 0 .001-2.18",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0BEFF",
    d: "M2.182 12.818a.818.818 0 1 0 0-1.636.818.818 0 0 0 0 1.636M12 3a.818.818 0 1 0 0-1.637A.818.818 0 0 0 12 3m0 19.636A.818.818 0 1 0 12 21a.818.818 0 0 0 0 1.636M5.046 5.875a.818.818 0 1 0 0-1.636.818.818 0 0 0 0 1.636m0 13.898a.818.818 0 1 0 0-1.636.818.818 0 0 0 0 1.636m13.909 0a.818.818 0 1 0 0-1.636.818.818 0 0 0 0 1.636"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillOpacity: 0.1,
    d: "M12 4.5c2.109 0 4.017.855 5.4 2.237l3.153-3.154-.068-.069L17.4 6.6A7.636 7.636 0 0 0 4.364 12l.001.068a7.635 7.635 0 0 1 7.636-7.567Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleAuth_svg__a",
    x1: 12.001,
    x2: 12.001,
    y1: 0,
    y2: 24.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5086FF"
  })))));
};
export { SvgGoogleAuth as ReactComponent };